import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import config from '../../config';
import { useQuery } from '../../utils';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

export default function FileView() {
  const key = useQuery().get('key') || undefined;
  const [fileContents, setFileContents] = useState();

  useEffect(() => {
    if (key) {
      let headers = new Headers();
      let bearer = 'Bearer ' + config.getTokenLocalStorage();
      headers.append('Authorization', bearer);
      let options = {
        method: 'GET',
        headers: headers
      };
      fetch(`/nld_tracker/s3/file_contents?key=${key}`, options)
        .then((data) => {
          if (key.endsWith('.json')) {
            return data.json();
          } else if (
            key.toLowerCase().endsWith('.jpg') ||
            key.toLowerCase().endsWith('.jpeg') ||
            key.toLowerCase().endsWith('.png')
          ) {
            return data.blob();
          } else {
            return data.text();
          }
        })
        .then((d) =>
          setFileContents(
            key.endsWith('.json')
              ? '<pre>' + JSON.stringify(d, null, 2) + '</pre>'
              : d
          )
        );
    }
  }, [key]);

  if (
    (typeof fileContents === 'string' &&
      !key.toLowerCase().endsWith('.jpg') &&
      !key.toLowerCase().endsWith('.jepg') &&
      !key.toLowerCase().endsWith('.png')) ||
    (typeof fileContents === 'object' &&
      (key.toLowerCase().endsWith('.jpg') ||
        key.toLowerCase().endsWith('.jpeg') ||
        key.toLowerCase().endsWith('.png')))
  ) {
    return (
      <>
        <Helmet>
          <title>FileView · NLD Refinement</title>
        </Helmet>
        {typeof fileContents === 'string' ? (
          <div
            dangerouslySetInnerHTML={{
              __html: fileContents.replace(/(?:\r\n|\r|\n)/g, '<br>')
            }}
          ></div>
        ) : (
          <div>
            <img alt='' src={URL.createObjectURL(fileContents)}></img>
          </div>
        )}
      </>
    );
  }
  return <LoadingSpinner />;
}
